import { settings } from './settings'

export const VERSION = 1.3
export const COLUMNS_MULTIPLIER = settings.resolution

export const HORIZONTAL_MARGIN_PERCENTAGE = 2.5
export const COLOUR_EASING = 100 // 50
export const BACKGROUND_COLOUR_EASING = 1200
export const FADE_SPEED = 0.01
